<!-- =========================================================================================
    File Name: Register.vue
    Description: Register Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 login-max-w sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color back-grey">

          <div class="vx-row no-gutter justify-center">

            <div class="vx-col hidden xl:block lg:w-1/2 px-4 py-5 color-bg-login ">
              <router-link to="/login" class="center-y-image">
                  <img class="mb-5 max-w-logo d-block m-auto" src="@/assets/images/logo/logo-full.svg" alt="registerImg">
                  <img src="@/assets/images/pages/register2.svg" alt="login" class="mx-auto">
              </router-link>
            </div>

            <div class="vx-col md:w-full lg:w-full xl:w-1/2 xl d-theme-dark-bg">
              <div class="p-8 login-tabs-container w-full">

                  <RegisterJwt  />

              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import RegisterJwt from './RegisterJWT.vue'


export default {
  components: {
    RegisterJwt
  }
}
</script>



